function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "37.072%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F0F0F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F0F0F5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "37.072%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F0F0F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F0F0F5"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  fillRule: "nonzero",
  stroke: "#BEBFCB",
  d: "M7.95 25.5l.263-13.85a2.5 2.5 0 0 1 2.5-2.453H13.5V2A1.5 1.5 0 0 0 12 .5H2A1.5 1.5 0 0 0 .5 2v22A1.5 1.5 0 0 0 2 25.5h5.95z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7A7B8E",
  d: "M5 14a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1zm0-6a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1zm0-5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h1zm5 0a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#498FFF",
  d: "M16.34 8c.917 0 1.66.834 1.66 1.862v3.684l-.202-.228a2 2 0 0 0-2.79-.193l-1.836 1.561a2 2 0 0 0-.21 2.84l.94 1.074h-2.064a1.152 1.152 0 0 0-1.336.936l-.102 4.247c-.086.621.34 1.197.96 1.296l1.766.521c-.173.122-.379.256-.563.4H4V9.862C4 8.834 4.743 8 5.66 8h10.68z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#003A79",
  d: "M10.491 20l-.091 3.783c-.086.621.34 1.197.96 1.296l1.64.484v.124c-.141.098-.295.203-.437.314L7 26v-5a1 1 0 0 1 1-1h2.491zM9 16a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1zm3.944 1.505a2 2 0 0 0 .019.022l.939 1.073-1.701.001A.996.996 0 0 1 12 18v-1a1 1 0 0 1 .47-.848c-.015.478.14.961.474 1.353zM9 11a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1zm5 0a1 1 0 0 1 1 1v1c0 .048-.003.095-.01.14l-1.012.86H13a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  fillRule: "nonzero",
  stroke: "#BEBFCB",
  d: "M28.437 20.036a6.649 6.649 0 0 0-.504-1.21l-.179-.333.271-.262 1.337-1.297c.26-.27.26-.695.008-.957l-1.266-1.26a.715.715 0 0 0-.984.006l-1.645 1.507-.312-.167a6.494 6.494 0 0 0-1.215-.5l-.357-.107v-2.262a.697.697 0 0 0-.7-.694h-1.805a.704.704 0 0 0-.703.694v2.27l-.357.107c-.419.124-.824.29-1.21.493l-.325.172-.26-.26-1.341-1.334a.71.71 0 0 0-.97-.008l-1.271 1.264a.68.68 0 0 0-.004.953l1.616 1.608-.18.33c-.21.381-.378.785-.501 1.202l-.106.358h-2.301a.694.694 0 0 0-.488.219.697.697 0 0 0-.184.516v1.799c0 .382.313.693.7.693h2.28l.107.358c.123.414.291.815.5 1.194l.182.33-.267.266-1.346 1.339a.685.685 0 0 0 .012.969l1.216 1.325a.687.687 0 0 0 .963.001l1.614-1.606.327.179a6.11 6.11 0 0 0 1.202.498l.359.105v2.273c0 .382.312.693.7.693h1.81a.695.695 0 0 0 .496-.202.684.684 0 0 0 .201-.491v-2.3l.362-.104c.419-.12.824-.288 1.207-.497l.326-.178.265.261 1.383 1.368a.687.687 0 0 0 .962.001l1.267-1.26c.259-.27.259-.695.008-.957l-1.615-1.606.178-.329c.207-.383.376-.786.503-1.202l.109-.353h2.282a.703.703 0 0 0 .515-.217.714.714 0 0 0 .189-.551V21.08a.687.687 0 0 0-.675-.69h-2.279l-.107-.355zM22 25.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7z"
}));

var SvgGestaoMunicipal = function SvgGestaoMunicipal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGestaoMunicipal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gestao-municipal.2ae84f5f.svg";
export { ForwardRef as ReactComponent };